module.exports = __webpack_public_path__ + "img/n2.194432e8.png";